import { render, staticRenderFns } from "./ModalConfig.vue?vue&type=template&id=9ab4345e&"
import script from "./ModalConfig.vue?vue&type=script&lang=js&"
export * from "./ModalConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports